<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'SatisEkle',
    props:[
        "data",
    ],
    data() {
        return {
            form: {},
            submitted: false,
        };
    },
    watch:{
        data(props){
            this.form = {...props}
        }
    },
    methods: {
      
        handleSubmit(){
            this.$http.post(`/dealers/${this.form.id}/balances/satis`, {...this.form, paymnet_type:this.paymnet_type})
            .then(resp => notify.success(resp.data.message))
        },

        close(){
            this.$parent.$bvModal.hide('satis_ekle')
        }
    },
};
</script>

<template>
<b-modal id="satis_ekle"  :title="`Satış Ekle > ${form.name}`"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">Ödenen Ücret</label>
            <div class="col">
                <input
                id="amount" 
                v-model="form.amount"
                type="text"
                class="form-control"
                />
            </div>
        </div>
        <div class="row d-flex flex-wrap mb-1" >
            <label class="col-sm-5 col-form-label col-form-label" for="explaine">Açıklama</label>
            <div class="col">
                <input
                id="explaine" 
                v-model="form.explaine"
                type="text"
                class="form-control"
                />
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Ekle
            </b-button>
        </div>
    </form>
</b-modal>
</template>